__turbopack_context__.v({
  "comparisonDesktop": "CkqTEG_comparisonDesktop",
  "comparisonDisclaimer": "CkqTEG_comparisonDisclaimer",
  "comparisonInner": "CkqTEG_comparisonInner",
  "comparisonMobile": "CkqTEG_comparisonMobile",
  "comparisonTitle": "CkqTEG_comparisonTitle",
  "headerImageCell": "CkqTEG_headerImageCell",
  "headerImagesRow": "CkqTEG_headerImagesRow",
  "headerLabel": "CkqTEG_headerLabel",
  "headerProduct": "CkqTEG_headerProduct",
  "headerProductPro": "CkqTEG_headerProductPro",
  "headerThumb": "CkqTEG_headerThumb",
  "headerTitlesRow": "CkqTEG_headerTitlesRow",
  "proColumnBg": "CkqTEG_proColumnBg",
  "root": "CkqTEG_root",
  "tableWrapper": "CkqTEG_tableWrapper",
});
